<div class="error-container">
    <h1>{{statusCode}}</h1>
    <p class="error-reason">{{errorHeader}}</p>
</div>